/**
 * The URL to return a fan to after onboarding, or undefined for the ordinary
 * "land on home" behavior.
 *
 * Deliberately narrow: an allowlist of the intents a fan can arrive with
 * before they have an account, never "wherever they happened to be". Every
 * other route keeps onboarding's existing exit behavior untouched.
 *
 * - A location carrying a `joinCode` search param. That is the Q227 case
 *   this exists for: a fan who followed a shared pool link and turned out to
 *   need an account first.
 * - The create pool entry (`/pools?dialog=create-pool`). A visitor who pressed
 *   "Start a pool" on the marketing site and is new (ISSUE-1101 R3).
 */
import { isCreatePoolIntent } from "../signIn/createPoolIntent";

export function pendingInviteRedirect(href: string): string | undefined {
  if (!href.startsWith("/") || href.startsWith("//")) return undefined;
  if (isCreatePoolIntent(href)) return href;
  const queryIndex = href.indexOf("?");
  if (queryIndex === -1) return undefined;
  const params = new URLSearchParams(href.slice(queryIndex + 1));
  const joinCode = params.get("joinCode");
  if (joinCode === null || joinCode === "") return undefined;
  return href;
}
